import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { finalize, Subject } from 'rxjs';
import { SpinnerService } from 'src/app/components/spinner/spinner.service';
import { FluxService } from 'src/app/service/flux-service';
import { Profile } from 'src/app/model/profile.model';
import { ROUTES } from 'src/app/route/routes';
import { HomeService } from 'src/app/service/home.service';
import { ProfileService } from 'src/app/service/profile.service';

@Component({
  selector: 'app-select-users',
  templateUrl: './select-users.component.html',
  styleUrls: ['./select-users.component.scss'],
  standalone: false
})
export class SelectUsersComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();

  isComplete: boolean = false;

  profiles: Array<Profile> = new Array<Profile>();

  available_users?: number;
  available_users_wl?: number;

  name: string;
  flux?: string;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private homeService: HomeService,
    private profileService: ProfileService,
    private spinner: SpinnerService,
    private fluxService: FluxService
  ) {
    this.name = 'FP';
  }

  ngOnInit(): void {
    this.spinner.show();
    this.fluxService.initializeFromRoute(this.route);
    this.flux = this.fluxService.getCurrentFlux();
    let profileObject =
      this.homeService.getProfileObject() &&
      this.homeService.getEditReservationObject()
        ? this.homeService.getProfileObject()![0]
        : null;

    let slotObject = this.homeService.getSlotObject();
    if (slotObject) {
      this.available_users = slotObject.available_users;
      this.available_users_wl = slotObject.available_users_wl;

      this.profileService
        .getAssociatedProfiles(
          slotObject.uuid_event_occurrence,
          profileObject?.uuid_passenger
        )
        .pipe(
          finalize(() => {
            this.spinner.hide();
          })
        )
        .subscribe({
          next: (result) => {
            if (result && result instanceof Array) {
              result.forEach((el) => {
                let nameTemp = el.displayName!.split(' ');
                nameTemp.map((n: any) => n[0]).join('');
                let name = [];
                name.push(nameTemp[0].substring(0, 1));
                name.push(nameTemp[nameTemp.length - 1].substring(0, 1));

                // for (let o of nameTemp) {
                //   name.push(o.substring(0, 1));
                // }

                let p = new Profile(
                  el.displayName,
                  el.badge_number,
                  el.can_reserve_occurrence,
                  el.can_access_event,
                  el.uuid_passenger
                );
                p.inizialiNome = name.join('');

                this.profiles.push(p);
              });
            }
            this.spinner.hide();
          },
          error: (err) => {
            console.error(err);
            this.spinner.hide();
          },
        });
    } else {
      this.goTo('calendar');
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  profileSelected(profile: Profile): void {
    if (profile.selectable && this.isAvailableUsers(profile)) {
      profile.selected = !profile.selected;
      // console.log(profile);
    }

    this.isComplete =
      this.profiles.find((p) => p.selected == true) != undefined;
  }

  goTo(path: string) {
    const currentFlux = this.fluxService.getCurrentFlux();
    switch (path) {
      case 'calendar': {
        this.router.navigate([currentFlux + '/' + ROUTES.EVENT_CALENDAR.path]);
        break;
      }

      case 'summary': {
        let selectedProfiles: Profile[] = this.profiles.filter(
          (p) => p.selected == true && p.selectable == true
        );
        if (selectedProfiles.length > 0) {
          this.homeService.saveProfileObject(selectedProfiles);
          this.router.navigate([currentFlux + '/' + ROUTES.EVENT_SUMMARY.path]);
        }
        break;
      }
    }
  }

  isAvailableUsers(el: Profile) {
    if (
      this.available_users != undefined &&
      this.available_users_wl != undefined
    ) {
      // controllo undefined esplicitamente, perché potrebbero essere == 0
      let countSelected = 0;
      this.profiles.forEach((profile) => {
        if (profile.selected) {
          countSelected = countSelected + 1;
        }
      });
      return (
        el.selected ||
        countSelected < this.available_users + this.available_users_wl
      );
    }
    return true;
  }
}
